import { ConsolidationGroupResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import { ConsolidationGroupStatus } from "@common/types/domains/accounting/consolidation";
import { useConsolidationGroups } from "@api/consolidation.api";
import { useCanUseConsolidation } from "@hooks/useCanUseConsolidation";
import { useScope } from "@state/scopeContext.lib";

interface ReportConsolidationGroup {
    consolidationGroup: ConsolidationGroupResponse | undefined;
    isResolving: boolean;
}

/**
 * Resolves the workspace's consolidation group for the P&L / Balance Sheet
 * report toolbars. Returns undefined unless the workspace can use consolidation
 * and a group exists, in which case the report can offer the consolidated layout.
 */
export function useReportConsolidationGroup(): ReportConsolidationGroup {
    const isConsolidationEnabled = useCanUseConsolidation();
    const { workspaceId } = useScope();
    const { data: groups, isLoading } = useConsolidationGroups(
        isConsolidationEnabled ? (workspaceId ?? null) : null,
    );

    if (!isConsolidationEnabled) {
        return { consolidationGroup: undefined, isResolving: false };
    }

    return {
        consolidationGroup: groups?.find(
            (group) => group.status === ConsolidationGroupStatus.active,
        ),
        isResolving: isLoading,
    };
}
